/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonthStatVo
 */
export interface MonthStatVo {
    /**
     * 月份（1-12）
     * @type {number}
     * @memberof MonthStatVo
     */
    month?: number;
    /**
     * 出库单数（当月产生佣金的去重订单数）
     * @type {number}
     * @memberof MonthStatVo
     */
    outboundOrderCount?: number;
    /**
     * 业绩（当月附加服务金额合计）
     * @type {number}
     * @memberof MonthStatVo
     */
    performanceAmount?: number;
    /**
     * 分成（当月佣金金额合计，含已结算与未结算）
     * @type {number}
     * @memberof MonthStatVo
     */
    commissionAmount?: number;
}

/**
 * Check if a given object implements the MonthStatVo interface.
 */
export function instanceOfMonthStatVo(value: object): value is MonthStatVo {
    return true;
}

export function MonthStatVoFromJSON(json: any): MonthStatVo {
    return MonthStatVoFromJSONTyped(json, false);
}

export function MonthStatVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthStatVo {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'] == null ? undefined : json['month'],
        'outboundOrderCount': json['outboundOrderCount'] == null ? undefined : json['outboundOrderCount'],
        'performanceAmount': json['performanceAmount'] == null ? undefined : json['performanceAmount'],
        'commissionAmount': json['commissionAmount'] == null ? undefined : json['commissionAmount'],
    };
}

export function MonthStatVoToJSON(json: any): MonthStatVo {
    return MonthStatVoToJSONTyped(json, false);
}

export function MonthStatVoToJSONTyped(value?: MonthStatVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'outboundOrderCount': value['outboundOrderCount'],
        'performanceAmount': value['performanceAmount'],
        'commissionAmount': value['commissionAmount'],
    };
}

